/**
 * 阵容概览表格组件
 * 以表格形式展示阵容的当前配置信息
 */
function TeamOverviewTable({ overview }) {
    if (!overview) return null;

    const { weapon, heroes } = overview;

    return (
        <div style={{ marginTop: '10px' }}>
            {/* 玩具信息 */}
            <div style={{ marginBottom: '10px', padding: '8px', backgroundColor: '#f0f9ff', borderRadius: '4px' }}>
                <span style={{ fontWeight: 'bold', color: '#1890ff' }}>【玩具】</span>
                <span style={{ marginLeft: '8px' }}>
                    {weapon.name === '未装备玩具' ? (
                        <span style={{ color: '#999' }}>未装备玩具</span>
                    ) : (
                        <>
                            <span style={{ color: '#333' }}>{weapon.name}</span>
                            <span style={{ marginLeft: '8px', color: '#666' }}>等级: {weapon.level}</span>
                            {weapon.passiveSkills.length > 0 && (
                                <span style={{ marginLeft: '8px', color: '#666' }}>
                                    被动: {weapon.passiveSkills.map((lv, i) => `${i + 1}-Lv.${lv}`).join(', ')}
                                </span>
                            )}
                        </>
                    )}
                </span>
            </div>

            {/* 咸将表格 */}
            {heroes && heroes.length > 0 && (
                <table
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: '12px',
                        backgroundColor: '#fff',
                    }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                            <th style={thStyle}>位置</th>
                            <th style={thStyle}>咸将</th>
                            <th style={thStyle}>等级</th>
                            <th style={thStyle}>速度</th>
                            <th style={thStyle}>出手</th>
                            <th style={thStyle}>装备</th>
                            <th style={thStyle}>洗练</th>
                            <th style={thStyle}>水晶</th>
                            <th style={thStyle}>鱼灵</th>
                            <th style={thStyle}>鱼珠洗练</th>
                            <th style={thStyle}>鱼珠技能</th>
                        </tr>
                    </thead>
                    <tbody>
                        {heroes.map((hero, index) => (
                            <tr
                                key={hero.slot}
                                style={{
                                    backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa',
                                }}>
                                <td style={tdStyle}>{hero.slot}</td>
                                <td style={{ ...tdStyle, fontWeight: 'bold', color: '#1890ff' }}>{hero.name}</td>
                                <td style={tdStyle}>{hero.level}</td>
                                <td style={tdStyle}>{hero.speed}</td>
                                <td style={{ ...tdStyle, color: '#666' }}>
                                    {hero.actionOrder}
                                </td>
                                <td style={tdStyle}>{hero.minEquipLevel}</td>
                                <td style={{ ...tdStyle, maxWidth: '150px', whiteSpace: 'pre-wrap' }}>
                                    {hero.quenchAttrs}
                                </td>
                                <td style={{ ...tdStyle, maxWidth: '120px', whiteSpace: 'pre-wrap' }}>
                                    {hero.trump}
                                </td>
                                <td style={{ ...tdStyle, color: '#52c41a' }}>{hero.artifact}</td>
                                <td style={{ ...tdStyle, maxWidth: '100px', whiteSpace: 'pre-wrap' }}>
                                    {hero.pearlAttrs}
                                </td>
                                <td style={{ ...tdStyle, color: '#fa8c16' }}>{hero.pearlSkill}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

const thStyle = {
    padding: '6px 4px',
    border: '1px solid #e8e8e8',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#666',
};

const tdStyle = {
    padding: '6px 4px',
    border: '1px solid #e8e8e8',
    textAlign: 'center',
    color: '#333',
};

/**
 * 阵容详情只读展示组件
 * 展示阵容的完整配置信息（编辑、删除、应用操作按钮已移至列表标题行）
 */
function TeamDetail({ team, appliedOverview }) {
    return (
        <div style={{ padding: '10px 0', fontSize: '14px' }}>
            {/* 玩具信息 */}
            {team.weaponName && (
                <div style={{ marginBottom: '10px' }}>
                    <span style={{ color: '#666' }}>玩具: </span>
                    <span style={{ color: '#1890ff', fontWeight: 'bold' }}>{team.weaponName}</span>
                </div>
            )}

            {/* 阵容位置 */}
            <div style={{ marginTop: '10px' }}>
                <div style={{ color: '#666', marginBottom: '8px' }}>出战配置:</div>
                {Object.entries(team.slots)
                    .sort(([a], [b]) => parseInt(a) - parseInt(b))
                    .map(([slotKey, slot]) => (
                        <div
                            key={slotKey}
                            style={{
                                marginBottom: '12px',
                                padding: '10px',
                                backgroundColor: '#f5f5f5',
                                borderRadius: '6px',
                                border: '1px solid #e8e8e8',
                            }}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '6px',
                                }}>
                                <span style={{ fontWeight: 'bold', color: '#333' }}>
                                    位置 {parseInt(slotKey) + 1}: {slot.heroName}
                                </span>
                                {slot.boundAttachment ? (
                                    <span style={{ fontSize: '12px', color: '#52c41a' }}>已绑定装备（洗练+水晶）</span>
                                ) : (
                                    slot.minHeroLevel > 0 && (
                                        <span style={{ fontSize: '12px', color: '#666' }}>等级≥{slot.minHeroLevel}</span>
                                    )
                                )}
                            </div>

                            {/* 属性信息 - 2行2列布局 */}
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: '4px 12px',
                                    fontSize: '12px',
                                }}>
                                {/* 装备等级 */}
                                {!slot.boundAttachment && slot.minEquipLevel > 0 && (
                                    <div style={{ color: '#666' }}>装备等级≥{slot.minEquipLevel}</div>
                                )}

                                {/* 关键属性 */}
                                {!slot.boundAttachment && slot.keyAttrNames && slot.keyAttrNames.length > 0 && (
                                    <div>
                                        <span style={{ color: '#666' }}>关键属性: </span>
                                        <span style={{ color: '#1890ff' }}>{slot.keyAttrNames.join('、')}</span>
                                    </div>
                                )}

                                {/* 鱼灵 */}
                                {slot.artifactName && (
                                    <div>
                                        <span style={{ color: '#666' }}>鱼灵: </span>
                                        <span style={{ color: '#52c41a' }}>{slot.artifactName}</span>
                                    </div>
                                )}

                                {/* 鱼珠技能 */}
                                {slot.pearlSkillName && (
                                    <div>
                                        <span style={{ color: '#666' }}>鱼珠技能: </span>
                                        <span style={{ color: '#fa8c16' }}>{slot.pearlSkillName}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
            </div>

            {/* 阵容概览 - 优先显示应用后的结果，其次显示数据库中的概览 */}
            {(appliedOverview || team.overview) && (
                <div style={{ marginTop: '10px' }}>
                    <div
                        style={{
                            color: '#666',
                            marginBottom: '8px',
                            fontWeight: 'bold',
                            borderBottom: '1px solid #e8e8e8',
                            paddingBottom: '4px',
                        }}>
                        当前阵容概览:
                    </div>
                    <TeamOverviewTable overview={appliedOverview || team.overview} />
                </div>
            )}
        </div>
    );
}

export default TeamDetail;
